import * as yup from 'yup'

import { LOGIN_FIELD, PASSWORD_FIELD } from '@/constants/forms/signIn'

export default yup.object().shape({
    [LOGIN_FIELD]: yup.string().email('Invalid email address').required('Please enter your email'),
    [PASSWORD_FIELD]: yup.string().required('Please enter your password')
})
